export default "__VITE_ASSET__B4e7xrbh__"